<template>
  <section :id="$style.shop_menu">
    <multiselect
      v-model="selected"
      :class="$style.select"
      :options="items"
      :selectLabel="''"
      :deselectLabel="''"
      :searchable="false"
      @select="handleClick"
      v-if="getWindowSize"
    ></multiselect>
    <side-menu-bar :items="items" @child_event="handleClick" v-else></side-menu-bar>
    <goods-list
      :items_data="items_data"
      :whats_new="whats_new"
      :top_flag="top_flag"
      :window_flag="!getWindowSize"
    ></goods-list>
  </section>
</template>

<script lang="ts">
import Vue from "vue";
import SideMenuBar from "@/components/organsms/shop/SideMenuBar.vue";
import GoodsList from "@/components/organsms/shop/GoodsList.vue";
import Multiselect from "vue-multiselect";
import { Shop } from "@/api";

export default Vue.extend({
  name: "ShopMenu",

  components: {
    SideMenuBar,
    GoodsList,
    Multiselect,
  },

  data() {
    return {
      items: [
        "トップ",
        "本",
        "色紙",
        "帽子",
        "キーホルダー",
        "バッグ",
        "タオル類",
        "衣類",
        "陶器",
        "菓子類",
        "文具",
        "DVD・CD",
        "雑貨",
      ],
      whats_new: [
      {
          year: "2024年9月",
          caption: "松井秀喜チョコサンドクッキーを追加しました。",
        },
        {
          year: "2023年2月",
          caption: "サーモタンブラー、マフラータオルを追加しました。",
        },
        {
          year: "2022年12月",
          caption: "今治製タオルハンカチを追加し、ポロシャツのデザインを変更しました。",
        },
      ],
      width: window.innerWidth,
      height: window.innerHeight,

      items_data: [{ category: "What's New" }],
      top_flag: true,
      selected: "トップ",
    };
  },

  mounted() {
    // window.addEventListener("resize", this.$store.commit("handleResize"));
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.$store.commit("handleResize"));
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    getWindowSize() {
      // return this.$store.state.width < 1023;
      return this.width <= 1023;
    },
  },
  methods: {
    handleClick(item) {
      if (item === "トップ") {
        this.items_data = [{ category: "What's New" }];
        this.top_flag = true;
      } else {
        Shop.getShopItem(item).then(({ results }) => {
          this.items_data = results;
        });
        this.top_flag = false;
      }
    },
    handleResize: function () {
      // resizeのたびにこいつが発火するので、ここでやりたいことをやる
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    },
  },
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #shop_menu {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
    .select {
      width: 200px;
    }
  }
}
@media only screen and (min-width: 1024px) {
  #shop_menu {
    display: flex;
    justify-content: center;
  }
  #shop_fig {
    height: 100px;
    width: 100px;
    border-radius: 30px;
    background-image: url("../../../assets/shop2.jpg");
    background-size: 100px 100px;
    background-repeat: no-repeat;
    margin: 0;
    margin-top: 80px;
  }
}
</style>
